import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Callout = makeShortcode("Callout");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Callout emoji='⚠️' mdxType="Callout">
      <p>{`This is an advanced configuration flag. You should discuss it with the Primer team before using it.`}</p>
    </Callout>
    <p>{`If set to `}<inlineCode parentName="p">{`true`}</inlineCode>{`, only merchant-allowed card networks can be used when paying with Apple Pay. If set to `}<inlineCode parentName="p">{`false`}</inlineCode>{` any network can be used provided the device supports Apple Pay.`}</p>
    <p>{`Merchant-allowed networks are provided using `}<a parentName="p" {...{
        "href": "https://primer.io/docs/api/api-reference/client-session-api/create-client-side-token#request.body.paymentMethod.orderedAllowedCardNetworks"
      }}><inlineCode parentName="a">{`orderedAllowedCardNetworks`}</inlineCode></a>{` when creating the client session.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      